module.exports = __webpack_public_path__ + "img/7d.af820fbf.png";